export default function Culinary() {
  return (
    <section className="py-24 px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="w-full h-[600px]">
            <img
              src="/demo/hotel-site/images/culinary.png"
              alt="Culinary Excellence"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="space-y-6">
            <p className="text-sm tracking-widest text-gray-500 uppercase">料理という芸術</p>
            <h3 className="text-4xl md:text-5xl font-serif text-gray-900 leading-tight">
              一皿に込められた、職人の矜持
            </h3>
            <p className="text-gray-600 leading-relaxed text-base">
              旬を知り尽くした料理人が、全国から届く最上の食材を一皿に昇華させます。伝統の技法に現代の感性を重ね、日本料理の新たな地平を切り拓きます。
            </p>
            <p className="text-gray-600 leading-relaxed text-base">
              メインダイニング「杜若」では本格懐石を、「スカイバー 蒼穹」では東京の夜景とともにカクテルを。それぞれの空間で、至福のひとときをお楽しみください。
            </p>
            <div className="grid grid-cols-2 gap-6 pt-6">
              <div>
                <h4 className="text-2xl font-serif text-gray-900 mb-2">懐石 杜若</h4>
                <p className="text-sm text-gray-600">ミシュラン二つ星</p>
              </div>
              <div>
                <h4 className="text-2xl font-serif text-gray-900 mb-2">スカイバー 蒼穹</h4>
                <p className="text-sm text-gray-600">東京パノラマビュー</p>
              </div>
            </div>
            <button className="mt-6 px-8 py-3 border border-gray-900 text-gray-900 text-sm tracking-wide whitespace-nowrap hover:bg-gray-900 hover:text-white transition-all">
              レストラン一覧
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}